import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams((location.hash || "").replace(/^#/, ""));
    const sid = params.get("session_id");
    (async () => {
      try {
        if (!sid) throw new Error("no session");
        const { user } = await api.googleSession(sid);
        setUser(user);
        window.history.replaceState(null, "", "/app");
        nav("/app", { replace: true, state: { user } });
      } catch {
        nav("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#0B0D11] flex items-center justify-center text-[#9A9CA6]">
      <Loader2 className="h-6 w-6 animate-spin mr-2 text-[#E8833A]" /> Signing you in…
    </div>
  );
}
